module.exports = __webpack_public_path__ + "8545d1b17ddc78fadc49fc53d4c9c8ff.pdf";